module.exports = __webpack_public_path__ + "static/media/diktat-32.c27fae6a.mp3";